import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import '../styles/App.css';
import constants from '../config/consts';

import Hello from '../pages/Hello';
import About from '../pages/About';
import Shop from '../pages/Shop';
import { WishlistProvider } from '../context/WishlistContext';
import Buy from '../pages/Buy';

function App() {
  const location = useLocation();
  
  return (
    <WishlistProvider>
      <div className="App">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route index path="/" element={<motion.div {...constants.PAGE_TRANSITION}> <Hello /></motion.div>}/>
            <Route path="/about" element={<motion.div {...constants.PAGE_TRANSITION}> <About /></motion.div>}/>
            <Route path="/toys/*" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='toys' /></motion.div>}/>
            <Route path="/toys/:id" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='toys' /></motion.div>}/>
            <Route path="/cards" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='cards' /></motion.div>}/>
            <Route path="/posters" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='posters' /></motion.div>}/>
            <Route path="/cubes" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='cubes' /></motion.div>}/>
            <Route path="/archive" element={<motion.div {...constants.PAGE_TRANSITION}> <Shop type='archive' /></motion.div>}/>
            <Route path="/buy" element={<motion.div {...constants.PAGE_TRANSITION}> <Buy /> </motion.div>}/>
          </Routes>
        </AnimatePresence>
      </div>
    </WishlistProvider>
  );
}

export default App;
